/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityTechResult } from './ControlEntityTechResult';
import {
    ControlEntityTechResultFromJSON,
    ControlEntityTechResultFromJSONTyped,
    ControlEntityTechResultToJSON,
} from './ControlEntityTechResult';

/**
 * 
 * @export
 * @interface ControlPaginatedEntityTechResponse
 */
export interface ControlPaginatedEntityTechResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityTechResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityTechResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityTechResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlEntityTechResult>}
     * @memberof ControlPaginatedEntityTechResponse
     */
    results?: Array<ControlEntityTechResult>;
}

/**
 * Check if a given object implements the ControlPaginatedEntityTechResponse interface.
 */
export function instanceOfControlPaginatedEntityTechResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlPaginatedEntityTechResponseFromJSON(json: any): ControlPaginatedEntityTechResponse {
    return ControlPaginatedEntityTechResponseFromJSONTyped(json, false);
}

export function ControlPaginatedEntityTechResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedEntityTechResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ControlEntityTechResultFromJSON)),
    };
}

export function ControlPaginatedEntityTechResponseToJSON(value?: ControlPaginatedEntityTechResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ControlEntityTechResultToJSON)),
    };
}

